/* eslint-disable */
import React, { useState, useEffect, useContext, useMemo } from "react";

import { MaterialReactTable } from "material-react-table";
import * as XLSX from "xlsx";

import { Link } from "react-router-dom";

import * as url from "urlhelpers/UrlHelper";
import { getData } from "utils/Gateway";

//import context
import { GlobalProvider } from "context/GlobalContext";

//import translation function for language translation
import { useTranslation } from "react-i18next";
import useMRTLocalization from "hooks/useMRTLocalization";

const MailTemplateList = ({
  downloadExcel,
  setRecords,
  checkedRecordCount,
}) => {
  const token = localStorage.getItem("token"); // token
  const { t } = useTranslation(); //for translation
  const mrtLocalization = useMRTLocalization();

  const {
    reloadMailTemplateList,
    setReloadMailTemplateList,
    setEditMailTemplateData,
    setCopyMailTemplateId,
    screenHeight,
    showMailTemplateNameColumn,
    showMailTemplateSlugColumn,
    showMailTemplateSubjectColumn,
    showMailTemplateLabelColumn,
    showMailTemplateDateColumn,
    searchMailTemplateDate,
    searchMailTemplateName,
    searchMailTemplateSubject,
    searchMailTemplateLabels,
    searchMailTemplateIsPublic,
  } = useContext(GlobalProvider);

  const [templateList, setTemplateList] = useState([]);
  const [responseReceived, setResponseReceived] = useState(false);
  const [rowSelection, setRowSelection] = useState({});

  const getSelectedData = () => {
    const selectedIds = Object.keys(rowSelection).filter((key) => rowSelection[key]);
    return templateList.filter((item) => selectedIds.includes(item._id));
  };

  /* Handle the button's onClick event and set it to export the data by using the ExcelExport save method. */
  const exportExcel = () => {
    const selectedData = getSelectedData();
    const exportData = selectedData.length > 0 ? selectedData : templateList;
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "Mail_Template.xlsx");
  };

  /* function to get all mail template data */
  const getMailTemplateList = async () => {
    try {
      let requestUrl =
        url.API_BASEURL + url.API_GET_ALL_TEMPLATE + `?token=${token}`;

      //search by date
      if (searchMailTemplateDate != "") {
        requestUrl = requestUrl + `&templatedate=${searchMailTemplateDate}`;
      }

      //search by name
      if (searchMailTemplateName != "") {
        requestUrl = requestUrl + `&templatename=${searchMailTemplateName}`;
      }

      //search by subject
      if (searchMailTemplateSubject != "") {
        requestUrl =
          requestUrl + `&templatesubject=${searchMailTemplateSubject}`;
      }

      //search by label
      if (searchMailTemplateLabels.length > 0) {
        requestUrl = requestUrl + `&templatelabels=${searchMailTemplateLabels}`;
      }

      //search by ispublic
      if (searchMailTemplateIsPublic) {
        requestUrl = requestUrl + `&ispublic=${searchMailTemplateIsPublic}`;
      }

      console.log("url of templatelist ========>>>", requestUrl);

      const response = await getData(requestUrl);

      console.log("get template response ========>>>", response);

      if (response.data) {
        setTemplateList(response.data);
        setResponseReceived(true);
        setRecords(response.data.length);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  /* custom name cell html */
  const customNameHtml = ({ dataItem }) => {
    return (
      <div className="kendoCustomColumn overflow-visible">
        <div className="d-flex align-items-center gap-2">
          <span>{dataItem.name} </span>

          <div className="ms-auto d-flex align-items-center gap-1">
            <Link
              to="#createEmailTemplatePopup"
              data-bs-toggle="offcanvas"
              className="edit_icon"
            >
              <span
                className="d-block material-symbols-outlined icon-md"
                onClick={() => {
                  setEditMailTemplateData(dataItem._id);
                }}
              >
                edit
              </span>
            </Link>

            {/* -------- dropdown section start -------- */}
            <div className="dropdown cell-dropdown mt-2">
              <button
                className="bg-transparent p-0 border-0"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <span className="d-block material-symbols-outlined">
                  more_vert
                </span>
              </button>

              <ul className="dropdown-menu border-0 shadow-lg">
                <li>
                  <Link
                    className="dropdown-item"
                    to="#createEmailTemplatePopup"
                    data-bs-toggle="offcanvas"
                    role="button"
                    aria-controls="saveReservationPopup"
                    onClick={() => {
                      setCopyMailTemplateId(dataItem._id);
                    }}
                  >
                    {t("Copy Mail Template")}
                  </Link>
                </li>
              </ul>
            </div>
            {/* -------- dropdown section end -------- */}
          </div>
        </div>
      </div>
    );
  };

  const tableColumns = useMemo(
    () => [
      ...(showMailTemplateNameColumn
        ? [
            {
              id: "name",
              accessorKey: "name",
              header: t("Template Name"),
              Cell: ({ row }) => customNameHtml({ dataItem: row.original }),
              size: 300,
              muiTableBodyCellProps: {
                sx: { overflow: "visible", position: "static" },
              },
            },
          ]
        : []),
      ...(showMailTemplateSlugColumn
        ? [
            {
              id: "slug",
              accessorKey: "slug",
              header: t("Slug"),
              size: 200,
            },
          ]
        : []),
      ...(showMailTemplateSubjectColumn
        ? [
            {
              id: "subject",
              accessorKey: "subject",
              header: t("Subject"),
              size: 200,
            },
          ]
        : []),
      ...(showMailTemplateLabelColumn
        ? [
            {
              id: "tagstring",
              accessorKey: "tagstring",
              header: t("Label"),
              size: 200,
            },
          ]
        : []),
      ...(showMailTemplateDateColumn
        ? [
            {
              id: "created",
              accessorKey: "created",
              header: t("Date"),
              size: 200,
            },
          ]
        : []),
    ],
    [
      t,
      templateList,
      showMailTemplateNameColumn,
      showMailTemplateSlugColumn,
      showMailTemplateSubjectColumn,
      showMailTemplateLabelColumn,
      showMailTemplateDateColumn,
    ]
  );

  useEffect(() => {
    if (
      searchMailTemplateDate != "" ||
      searchMailTemplateName != "" ||
      searchMailTemplateSubject != "" ||
      searchMailTemplateLabels.length > 0 ||
      searchMailTemplateIsPublic
    ) {
      getMailTemplateList();
    }
  }, [
    searchMailTemplateName,
    searchMailTemplateSubject,
    searchMailTemplateDate,
    searchMailTemplateLabels,
    searchMailTemplateIsPublic,
  ]);

  /* hook to reload list */
  useEffect(() => {
    if (reloadMailTemplateList || !responseReceived) {
      getMailTemplateList();
      checkedRecordCount(0);
      if (reloadMailTemplateList) {
        setReloadMailTemplateList(false);
      }
    }
  }, [reloadMailTemplateList, responseReceived]);

  /* hook to hit exportExcel() function*/
  useEffect(() => {
    downloadExcel && exportExcel();
  }, [downloadExcel]);

  /* set records based on templateList */
  useEffect(() => {
    setRecords(templateList.length);
  }, [templateList]);

  /* sync selected count to parent */
  useEffect(() => {
    const selectedCount = Object.keys(rowSelection).filter((key) => rowSelection[key]).length;
    checkedRecordCount(selectedCount);
  }, [rowSelection, templateList]);

  return (
    <div className="activity_table">
      <div className="table-responsive">
        {/* ========= MaterialReactTable start ======= */}
        <MaterialReactTable
          localization={mrtLocalization}
          columns={tableColumns}
          data={templateList}
          enableSorting
          enableFilters
          enableGlobalFilter
          enableColumnFilterModes={false}
          muiTableHeadCellProps={{ title: "" }}
          enableGrouping
          enableColumnOrdering
          enableStickyHeader
          enableRowSelection
          onRowSelectionChange={setRowSelection}
          getRowId={(row) => row._id}
          state={{ rowSelection }}
          muiTableContainerProps={{ sx: { maxHeight: screenHeight } }}
          muiTableBodyRowProps={{ sx: { overflow: "visible" } }}
          muiTableBodyProps={{ sx: { overflow: "visible" } }}
          initialState={{
            pagination: { pageSize: 100, pageIndex: 0 },
            showColumnFilters: true,
          }}
        />
        {/* ========= MaterialReactTable end ======= */}
      </div>
    </div>
  );
};

export default MailTemplateList;
